import { CodeDescriptionSearchData } from '../types-store';

export const getCodeDataId = (codeData: CodeDescriptionSearchData) =>
  `${codeData.id}_${codeData.codetable ? codeData.codetable.v : ''}_${codeData.language ? codeData.language.v : ''}`;
